import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

export const emptyResponseBodyInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err.status >= 200 && err.status < 300) {
                const res = new HttpResponse({
                    body: null,
                    headers: err.headers,
                    status: err.status,
                    statusText: err.statusText,
                    url: err.url
                });

                return of(res);
            } else {
                return throwError(() => err);
            }
        })
    );
};
